// The role buckets People groups by — Manager, Front Desk Associates, LMTs &
// ESTs, then Other — shared so Pay & Hours groups the same people the same
// way (owner, 2026-09-23: "display like we display people"). The reasoning
// behind each role list lives on People.tsx's bucketPeople.

/** Front desk: `FD` is what ADP data says, `FRONT_DESK` what this app's
 * vocabulary says, `FD_MANAGER` a front-desk lead — same job. */
export const FRONT_DESK_ROLES = ['FD', 'FRONT_DESK', 'FD_MANAGER'];

/** The service floor: the roster's own codes. */
export const SERVICE_ROLES = ['LMT', 'EST'];

export const ROLE_BUCKETS = ['MANAGER', 'FRONT_DESK', 'SERVICE', 'OTHER'] as const;
export type RoleBucket = (typeof ROLE_BUCKETS)[number];

export const ROLE_BUCKET_TITLE: Record<RoleBucket, string> = {
  MANAGER: 'Manager',
  FRONT_DESK: 'Front Desk Associates',
  SERVICE: 'LMTs & ESTs',
  OTHER: 'Other roles',
};

/** An unrecognised role lands in OTHER by name, never guessed into a bucket. */
export function roleBucket(role: string | null | undefined): RoleBucket {
  const r = (role ?? '').toUpperCase();
  if (r === 'MANAGER') return 'MANAGER';
  if (FRONT_DESK_ROLES.includes(r)) return 'FRONT_DESK';
  if (SERVICE_ROLES.includes(r)) return 'SERVICE';
  return 'OTHER';
}
